import { AxiosError } from "axios";
import { UserAPIdata } from "../models/userAPIdata";
import axiosClient from "./axios";

export const ProcessLoginUserData = async (data: UserAPIdata): Promise<{ succeeded: boolean; data?: any }> => {
  try {
    const response = await axiosClient.post("User/ProcessLogin", data);
    return { succeeded: response?.data?.succeeded, data: response?.data?.data };
  } catch (error: any) {
    console.error("Error in ProcessLoginUserData:", error.response?.data || error.message);
    return { succeeded: false, data: null };
  }
};

export const processLogout = async () => {
  try {
    await axiosClient.post("User/ProcessLogout");
    localStorage.clear();
    sessionStorage.clear();
  } catch (error) {
    console.error("Logout failed:", error);
  }
};

export const GetCventLink = async (apidata: any): Promise<{ succeeded: boolean; data?: any }> => {
  try {
    const response = await axiosClient.post("api/Enrollment/GetCventLink", apidata);
    return {
      succeeded: response?.data?.succeeded,
      data: response?.data?.data,
    };
  } catch (error: any) {
    console.error("Error in GetCventLink:", error.response?.data || error.message);
    return { succeeded: false, data: null };
  }
};

export const getDashboardReport = async (eventCode: string, reportHeaders: string) => {
  try {
    const userdetails = localStorage.getItem("userdetail");
    let token = userdetails ? JSON.parse(userdetails).accessToken : null;
    if (!token) {
      return { fileBlob: null, fileName: "", message: "Un-Authorized Access" };
    }

    const response = await axiosClient.get("api/Report/GetRetailerReport", {
      params: { eventCode, reportHeaders },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response || !response.data || response.data.reportData === null) {
      const message = response?.data?.message || "No data found";
      return { fileBlob: null, fileName: "", message };
    }

    const reportData = response.data.reportData;
    const fileName = reportData.fileDownloadName || 'Retailer_Report';

    if (!reportData.fileContents) {
      return { fileBlob: null, fileName, message: "No file data available" };
    }

    const byteCharacters = atob(reportData.fileContents);
    const byteArrays: Uint8Array[] = [];

    for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
      const slice = byteCharacters.slice(offset, offset + 1024);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      byteArrays.push(new Uint8Array(byteNumbers));
    }

    const totalLength = byteArrays.reduce((sum, currentArray) => sum + currentArray.length, 0);
    const byteArray = new Uint8Array(totalLength);

    let offset = 0;
    byteArrays.forEach((arr) => {
      byteArray.set(arr, offset);
      offset += arr.length;
    });

    const blob = new Blob([byteArray], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    return { fileBlob: blob, fileName, message: "Report Generated Successfully" };

  } catch (error: unknown) {
    if (error instanceof AxiosError) {
      return { fileBlob: null, fileName: "", message: error.response?.data?.message || "Request failed" };
    }
    return { fileBlob: null, fileName: "", message: "An unexpected error occurred" };
  }
};
	